<template>
    <v-layout justify-center>
        <v-responsive max-width="1080" width="100%" height="100%" class="px-3 mx-n3">
            <list-heading title="브릿지 프로그램 목록" v-model="showsSearch" showsFilterButton />

            <expo-program-list-search v-bind="{ showsSearch }" />

            <v-data-table v-bind="{ loading, headers, items }" disable-sort disable-pagination hide-default-footer class="v-sheet--outlined" :items-per-page="-1" style="overflow: hidden">
                <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value }"> {{ header.formatter(value) }} </template>
                <template #[`item.host`]="{ value }">
                    <span> {{ value.user?.name || "-" }} ({{ value.user?.username || "-" }}) </span>
                </template>
                <template #[`item.subject`]="{ item, value }">
                    <v-list-item :href="`/programs/${item._id}`">
                        <v-list-item-avatar color="grey lighten-3" rounded size="64">
                            <v-img :src="item?.thumb?.src" class="v-sheet--outlined">
                                <template #placeholder>
                                    <v-icon>mdi-image-broken-variant</v-icon>
                                </template>
                            </v-img>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-subtitle class="text-truncate"> {{ item.host?.name }} </v-list-item-subtitle>
                            <v-list-item-title class="text-truncate"> {{ value }} </v-list-item-title>
                            <p class="mt-2 mb-0 text-truncate">{{ item.summary }}</p>
                        </v-list-item-content>
                    </v-list-item>
                </template>
                <template #[`item.isGranted`]="{ item }">
                    <v-switch v-model="item.isGranted" v-bind="attrs_switch__console" class="ml-n2" @change="(isGranted) => update({ _id: item._id, isGranted })" />
                </template>
                <template #[`item.actions`]="{ item }">
                    <v-btn small text icon tile :to="`/console/expo/programs/${item._id}`">
                        <v-icon small> mdi-eye </v-icon>
                    </v-btn>
                </template>
            </v-data-table>
            <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" class="mt-2" @input="(page) => $router.push({ query: { ...$route.query, page } })"></v-pagination>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import { attrs_switch__console } from "@/assets/variables";

import ListHeading from "@/components/console/dumb/list-heading.vue";
import ExpoProgramListSearch from "@/components/console/expo/programs/list/expo-program-list-search.vue";

export default {
    components: {
        ListHeading,
        ExpoProgramListSearch,
    },
    data: () => ({
        programs: [],

        limit: 10,
        summary: { totalCount: 0 },

        loading: false,
        showsSearch: true,
        attrs_switch__console,
    }),
    computed: {
        items() {
            return [...this.programs];
        },
        headers() {
            return [
                {
                    width: +60,
                    text: "#",
                    value: "index",
                    align: "end",
                },
                {
                    width: 160,
                    text: "사용자",
                    value: "host",
                    cellClass: "text-truncate max-width-0",
                },
                {
                    text: "제목",
                    value: "subject",
                    cellClass: "text-truncate max-width-0 px-0",
                },
                {
                    width: 100,
                    text: "생성일시",
                    value: "createdAt",
                    formatter: (value) => value?.toDateTime?.(),
                },
                {
                    width: 100,
                    text: "갱신일시",
                    value: "updatedAt",
                    formatter: (value) => value?.toDateTime?.(),
                },
                {
                    width: +80,
                    text: "승인",
                    value: "isGranted",
                    align: "center",
                },
                // {
                //     width: +60,
                //     text: "",
                //     value: "actions",
                // },
            ].map((item, index, array) => ({ ...item, divider: index != array.length - 1, cellClass: (item.cellClass || "") + " caption", formatter: item.formatter ?? ((value) => value ?? "-") }));
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;
            return { ...query };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        async init() {
            try {
                this.search();
            } catch (error) {
                console.error(error);
            }
        },

        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { skip, limit, params } = this;
                var { summary, programs } = await api.console.expo.programs.gets({
                    headers: { skip, limit },
                    params,
                });

                this.summary = summary;
                this.programs = programs.map((item, index) => ({ index: summary.totalCount - (this.page - 1) * this.limit - index, ...item }));
            } finally {
                this.loading = false;
            }
        },

        async update(program) {
            if (this.loading) return;
            else this.loading = true;

            try {
                program = (await api.console.expo.programs.put(program))?.program;
                this.updateItem(program);
            } finally {
                this.loading = false;
                this.search();
            }
        },

        updateItem(program) {
            const index = this.programs.findIndex(({ _id }) => _id == program._id);
            if (0 <= index) this.programs.splice(index, 1, program);
            else {
                this.programs = [program, ...this.programs];
                this.summary.totalCount += 1;
            }
            this.search();
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .max-width-0 {
        max-width: 0;
    }
    .white-space-pre-line {
        white-space: pre-line;
    }
    .v-pagination button {
        box-shadow: none !important;
        border: thin solid rgba(0, 0, 0, 0.12);
    }
}
</style>
